<template>
  <div class="Announcement">
    <div class="top">
      <div class="left">
        <div class="leftBar"></div>
      </div>
      <div class="right">
        <div class="rightBar">
          <label>歡迎使用本系統，{{ username }}</label>
        <!-- <a href="/#/Download">表格下載</a> -->
          <!-- <a href="">最新消息</a> -->
          <button @click="logout()">帳號登出</button>
          <a href=""> <img src="../../assets/img/Logo.png" alt="" /></a>
        </div>
      </div>
    </div>

    <!--添加-->
    <div>
      <h1>新增公告</h1>
      <div class="announceContent" style="margin-left: 5%">
        <textarea
          class="textSearch Text"
          placeholder="請輸入公告內容..."
          v-model="text"
        /><br /><br />
        <button
          class="btnAdd"
          style="background-color: #ffffff; margin: 3px 0px"
          @click="doAnnounce"
        >
        發送公告
        </button>
      </div>
    </div>
    <div style="height:60px"></div>
  </div>
</template>


<script>
import axios from "axios";
import userService from "../../services/user.services";
import authService from "../../services/auth.service";
import announceService from "../../services/announce.service";
import userData from "../../js/userData";

export default {
  data() {
    return {
      username: "",
      activeName: "2",
      menuList: [],
      authList: [],
      text: "",
    };
  },
  mounted() {
    //token驗證
    this.tokenCheck();
    //權限確認
    this.Auth();
  },
  methods: {
    /** token驗證 */
    async tokenCheck() {
      let tc = await userService.tokenCheck();

      if (tc.Response != "Succeed") {
        alert("登入已逾期，請重新登入");
        localStorage.clear();
        await this.$router.push("/");
      }
    },
    /** 權限判別 */
    Auth() {
      this.username = userData().emp_name;
      if (userData().auth == "A") {
        this.Admin = true;
      }
    },
    /** 登出 */
    async logout() {
      await authService.logout();
      await this.$router.push("/");
       window.location.reload();
    },

    //發公告
    async doAnnounce() {
      await announceService.announce(this.text);
    }
  },
};
</script>

<style>
@import "../../assets/css/announcement.css";
</style>